import { ComputedRef, Ref } from 'vue';

export const NEWS_CONTEXT_TYPES = {
  observer: 8,
  codal: 16,
} as const;

export const VALID_NEWS_FILTER_KEYS = [
  'instruments',
  'portfolio',
  'fromDate',
  'endDate',
  'virtualPortfolio',
];

export const NEWS_QUERY_KEYS = {
  news: (params: ComputedRef<string>) => ['news', params],
  newsItem: (id: Ref<string>) => ['news-item', id],
};
